import { cloneDeep } from "common/utils/core";
import { jotaiStore, summaryAtom } from "components/jiffy/react-product-details-dtf/store.atoms";

// eslint-disable-next-line import/prefer-default-export
export class DtfPricesDecorator {
  extraCharge = 0;

  updateCostInfo(data) {
    const newData = cloneDeep(data);
    const { cart_dates: cartDates, composition_dates: compositionDates } = newData;
    this.#applyExtraCharge(cartDates);
    this.#applyExtraCharge(compositionDates);
    return newData;
  }

  // HB-1974: only re-derive the free-shipping signal from the enhancement-adjusted
  // shortfall when the rule actually has a positive free-shipping threshold.
  // Zero-threshold rules (e.g. Sample Stickers) have no free-shipping offer, so the
  // backend's `free` flag is authoritative — deriving it from amount_until_free <= 0
  // would otherwise advertise "free shipping" to a charged guest / repeat sampler.
  #applyExtraCharge(dates) {
    const info = dates?.shipping_cost_info;
    if (!info || !(info.free_shipping_threshold > 0)) return;

    info.amount_until_free -= this.extraCharge;
    info.free = info.amount_until_free <= 0;
  }

  #unsubscribe = null;

  #updateExtraCharge() {
    const summary = jotaiStore.get(summaryAtom);
    this.extraCharge = 0;
    Object.values(summary?.enhancements || {}).forEach(enhancement => {
      this.extraCharge += parseFloat(enhancement.totalPrice) || 0;
    });
  }

  subscribe() {
    this.#unsubscribe = jotaiStore.sub(summaryAtom, () => {
      this.#updateExtraCharge();
    });
    this.#updateExtraCharge();
  }

  unsubscribe() {
    this.#unsubscribe?.();
    this.#unsubscribe = null;
  }
}
